module.exports = __webpack_public_path__ + "img/multicurrency.530f918b.png";